<style scoped lang="scss">
.document-container {
  padding: 10px 25px;
  border: thin solid #999;
  align-items: center;

  .icon-container {
    margin-right: 20px;
  }

  .document-title {
    font-size: 1.2em;
    margin-bottom: 2px;
  }

  .details {
    color: #666;
  }
}
</style>

<template>
  <div class="step-wrapper uk-form" v-if="application && confirmation">

    <div class="uk-grid uk-margin-large-bottom">
      <div class="uk-align-center uk-width-small-1-1 uk-width-medium-4-5">
        <div class="uk-grid">
          <div class="uk-width-1-1">
            <h2>Thank You!</h2>
          </div>
        </div>

        <div class="uk-grid renter-info">
          <div class="uk-width-1-1 uk-margin-bottom">
            <h2>Which company will receive funds and the 1099 from us?</h2>
            <select class="uk-form-large uk-width-1-1 uk-select"
                    @change="updatePayeeOrganizationId"
                    v-model="project.payee_organization_id">
              <option :value="null">Select a Company...</option>
              <option v-if="ownerOrganization" :value="ownerOrganization.id">{{
                  ownerOrganization.organization_name
                }}
              </option>
              <option v-if="managerOrganization && managerOrganization.id != ownerOrganization.id"
                      :value="managerOrganization.id">{{ managerOrganization.organization_name }}
              </option>
            </select>
          </div>

          <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-top">
            <p class="uk-margin-bottom-remove"><small>&nbsp;Enter the tax id or social security number of the
              Company</small></p>
            <validated-section :errors="errors" field="tax_id_number">
              <input type="text"
                     v-if="maskedTaxIdNumber"
                     :value="maskedTaxIdNumber"
                     class="uk-form-large uk-width-1-1"
                     disabled="disabled"
                     placeholder="Tax ID Number"
              >
              <input type="text"
                     v-else
                     v-model="taxIdNumber"
                     class="uk-form-large uk-width-1-1"
                     v-mask="'#########'"
                     placeholder="Tax ID Number"
              >
            </validated-section>
          </div>

          <div class="uk-width-1-1" v-if="project.payee_organization_id != null">
            <h2>Please upload a W9 for payment reimbursement</h2>
          </div>
          <div class="uk-width-1-1 uk-margin-top uk-margin-bottom" v-if="project.payee_organization_id != null">
            <p style="font-size: 1.2em;">
              You can download a copy of the current W9 file from the IRS
              <span v-if="w9Category && w9Category.attestations.length">
                <a class="uk-button uk-button-primary" :href="w9Category.attestations[0].url" target="_blank">Here</a>
              </span>
              <span v-else>
                <a class="uk-button uk-button-primary" href="https://www.irs.gov/pub/irs-pdf/fw9.pdf" target="_blank">Here</a>
              </span>
            </p>
          </div>

          <template v-if="project.payee_organization_id != null">
            <div class="uk-width-1-1 uk-grid uk-margin-remove" v-if="documentsOfType('landlord-w9').length > 0">
              <div class="uk-width-1-1 document-container uk-flex uk-flex-space-between">
                <div class="uk-flex uk-center">
                  <div>
                    <div class="document-title">W9 Uploaded</div>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <div class="uk-width-1-1 uk-margin-top" v-if="project.payee_organization_id != null">
            <validated-section field="landlord-w9" :errors="errors">
              <file-upload-row
                  :upload-url="'/api/landlord/documents/'+confirmation.id+'/landlord-w9'"
                  :params="{organization_id: project.payee_organization_id}"
                  @uploaded="onUploaded"/>
            </validated-section>
          </div>

        </div>

        <div class="uk-grid" v-if="project.payee_organization_id != null">
          <div class="uk-width-1-1 uk-width-medium-1-2 uk-width-small-1-1">
            <h3>Payment Method</h3>
            <validated-section :errors="errors" field="payment_type">
              <select v-model="paymentType" class="uk-width-small-1-1 uk-form-select uk-form-large">
                <option v-for="option in paymentTypeOptions" :key="option.value" :value="option.value">
                  {{ option.label }}
                </option>
              </select>
            </validated-section>

          </div>
        </div>

        <template v-if="paymentType == 2 && project.payee_organization_id != null">
          <div class="uk-grid">

            <div class="uk-width-small-1-1 uk-width-medium-1-2 uk-margin-large-bottom">
              <p class="uk-margin-bottom"><small>&nbsp;Account Type</small></p>
              <validated-section :errors="errors" field="account_type">
                <div class="uk-grid">
                  <div class="uk-width-1-2">
                    <label for="bank_account_type">
                      <input type="radio" v-model="accountType" :value="1">
                      Checking
                    </label>
                  </div>

                  <div class="uk-width-1-2">
                    <label for="bank_account_type">
                      <input type="radio" v-model="accountType" :value="2">
                      Savings
                    </label>
                  </div>
                </div>
              </validated-section>
            </div>

            <div class="uk-width-small-1-1 uk-width-medium-1-2">
              &nbsp;
            </div>

            <div class="uk-width-1-1 uk-width-medium-1-2 uk-width-small-1-1">
              <p class="uk-margin-bottom-remove"><small>&nbsp;Routing Number</small></p>
              <input type="text"
                     v-if="maskedRoutingNumber"
                     :value="maskedRoutingNumber"
                     disabled="disabled"
                     class="uk-form-large uk-width-1-1"
              />
              <input type="text"
                     v-else
                     class="uk-form-large uk-width-1-1"
                     v-mask="'#########'"
                     v-model="routingNumber"/>
            </div>
            <div class="uk-width-1-1 uk-width-medium-1-2 uk-width-small-1-1">
              <p class="uk-margin-bottom-remove"><small>&nbsp;Routing Number Confirmation</small></p>
              <input type="text"
                     v-if="maskedRoutingNumber"
                     :value="maskedRoutingNumber"
                     disabled="disabled"
                     class="uk-form-large uk-width-1-1"
              />
              <input type="text"
                     v-else
                     class="uk-form-large uk-width-1-1"
                     v-mask="'#########'"
                     v-model="routingNumberConfirmation"/>
            </div>
            <div class="uk-width-1-1">
              <validated-section field="routing_number" :errors="errors"></validated-section>
            </div>
          </div>

          <div class="uk-grid">
            <div class="uk-width-1-1 uk-width-medium-1-2 uk-width-small-1-1">
              <p class="uk-margin-bottom-remove"><small>&nbsp;Account Number</small></p>
              <input type="text"
                     v-if="maskedAccountNumber"
                     :value="maskedAccountNumber"
                     disabled="disabled"
                     class="uk-form-large uk-width-1-1"
              />
              <input type="text"
                     v-else
                     class="uk-form-large uk-width-1-1"
                     v-mask="'#####################'"
                     v-model="accountNumber"
              >
            </div>
            <div class="uk-width-1-1 uk-width-medium-1-2 uk-width-small-1-1">
              <p class="uk-margin-bottom-remove"><small>&nbsp;Account Number Confirmation</small></p>
              <input type="text"
                     v-if="maskedAccountNumber"
                     :value="maskedAccountNumber"
                     disabled="disabled"
                     class="uk-form-large uk-width-1-1"
              />
              <input type="text"
                     v-else
                     class="uk-form-large uk-width-1-1"
                     v-mask="'#####################'"
                     v-model="accountNumberConfirmation"
              />
            </div>
            <div class="uk-width-1-1">
              <validated-section field="account_number" :errors="errors"></validated-section>
            </div>

            <div class="uk-width-1-1 uk-grid uk-margin-top">
              <h2 class="uk-margin-bottom">{{ program.settings['void-check-title'] }}</h2>
              <div class="uk-width-1-1 uk-margin-top uk-margin-bottom"
                   v-if="documentsOfType('void_check').length === 0">
                <p style="font-size: 1.2em;">
                  For the ACH form, click <a class="uk-text-primary"
                                             href="downloads/templates/EFT Form_Final_04_15_2021.pdf" target="_blank">here </a>
                </p>
              </div>
              <div class="uk-width-1-1 uk-grid uk-margin-remove" v-if="documentsOfType('void_check').length > 0">
                <div class="uk-width-1-1 document-container uk-flex uk-flex-space-between">
                  <div class="uk-flex uk-center">
                    <div>
                      <div class="document-title">Void Check Uploaded</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div class="uk-width-1-1 uk-margin-top">
              <validated-section field="void_check" :errors="errors">
                <file-upload-row
                    ref="checkFileUpload"
                    accepts="application/pdf,image/png,image/jpg"
                    :params="{organization_id: project.payee_organization_id}"
                    :upload-url="'/api/landlord/documents/'+confirmation.id+'/void_check'"
                    @uploaded="onUploaded"
                    fileType="void_check"
                />
              </validated-section>
            </div>
          </div>
        </template>


      </div>
    </div>
    <preview-documents-modal ref="previewModal"></preview-documents-modal>
    <edit-documents-modal v-if="permissions.processor" ref="editModal" @confirm="onEditConfirm"></edit-documents-modal>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import FileUploadRow from "../../../../components/FileUploadRow";
import ValidatedSection from "../../../components/Common/ValidatedSection";
import PreviewDocumentsModal from "../../../../dashboard/pages/Documents/PreviewDocumentModal";
import EditDocumentsModal from "../../../../dashboard/pages/Documents/EditDocumentsModal";
import FinancialInformation from "../../../../dashboard/pages/Projects/Wizard/Steps/FinancialInformation";
import AutocompletedAddressForm from "../../../../dashboard/components/Common/AutocompletedAddressForm";

export default {
  name: "Step2",
  components: {
    AutocompletedAddressForm,
    FinancialInformation, EditDocumentsModal, PreviewDocumentsModal, ValidatedSection, FileUploadRow
  },
  data() {
    return {
      errors: {},
      paymentType: null,
      accountType: null,
      maskedRoutingNumber: '',
      routingNumber: '',
      routingNumberConfirmation: '',
      maskedAccountNumber: '',
      accountNumber: '',
      accountNumberConfirmation: '',
      newProjectName: '',
      maskedTaxIdNumber: '',
      taxIdNumber: '',
    }
  },
  computed: {
    paymentInformationComplete() {
      let complete = true;
      if (this.documentsOfType('landlord-w9').length == 0) {
        complete = false;
      }
      if (this.documentsOfType('void_check').length == 0) {
        complete = false;
      }
      if (this.managerOrganization) {
        if (!this.managerOrganization.masked_account_number) {
          complete = false;
        }
        if (!this.managerOrganization.masked_routing_number) {
          complete = false;
        }
      }

      return complete;
    },
    w9Category() {
      return _.find(this.documentCategories, {key: 'landlord-w9'})
    },
    checkDocuments() {
      return this.documents ? this.documents.filter(item => item.file_type === 'void_check') : []
    },
    countiesForState() {
      if (!this.newProjectAddress.state_id) return [];

      return _.filter(this.counties, county => county.state_id === this.newProjectAddress.state_id);
    },
    paymentTypeOptions() {
      let returnValue = [];
      let options = this.program.setting_details['organization-payment-types'].options;
      for (let i in options) {
        if (this.hasPaymentType(i)) {
          returnValue.push({label: options[i], value: i})
        }
      }
      return returnValue;
    },
    ...mapState('Application', {
      assets: 'assets',
      application: state => state.application,
      applicant: state => state.applicant,
      renterOwner: state => state.renterOwner,
      renterManager: state => state.renterManager,

      program: state => state.application.program,
      states: state => state.assets.states,
      counties: state => state.assets.counties,
      project: state => state.project,
    }),
    ...mapState('Project', {
      documents: state => state.documents,
      ownerOrganization: state => state.ownerOrganization,
      managerOrganization: state => state.managerOrganization,
    }),
    ...mapState('Landlord', {
      confirmation: state => state.confirmation,
      documentCategories: state => state.documentCategories,
    }),
    ...mapState('App', {
      permissions: state => state.permissions,
    }),
    ...mapGetters('Project', [
      'payeeOrganization',
    ])
  },
  watch: {
    'payeeOrganization': {
      handler: function (newValue, oldValue) {
        if (!oldValue || newValue && newValue.id != oldValue.id) {
          this.paymentType = newValue.payment_type;
          this.accountType = newValue.bank_account_type;
          this.maskedRoutingNumber = newValue.masked_routing_number;
          this.maskedAccountNumber = newValue.masked_account_number;
          if (newValue.masked_tax_id_number) {
            this.maskedTaxIdNumber = newValue.masked_tax_id_number;
          } else {
            this.taxIdNumber = '';
          }

          this.$store.dispatch('Project/fetchOrgDocument', newValue.id);
        }
      }
    },
  },
  mounted() {
    if (this.application) {
      if (!this.project.payee_organization_id) {
        if (this.renterOwner && this.renterOwner.organization_id) {
          this.project.payee_organization_id = this.renterOwner.organization_id;
        } else if (this.renterManager && this.renterManager.organization_id) {
          this.project.payee_organization_id = this.renterManager.organization_id;
        }
      }
    }

    if (this.payeeOrganization) {
      this.paymentType = this.payeeOrganization.payment_type;
      this.accountType = this.payeeOrganization.bank_account_type;
      this.maskedRoutingNumber = this.payeeOrganization.masked_routing_number;
      this.maskedAccountNumber = this.payeeOrganization.masked_account_number;
      this.maskedTaxIdNumber = this.payeeOrganization.masked_tax_id_number;

      this.$store.dispatch('Project/fetchOrgDocument', this.payeeOrganization.id);
    }
  },
  methods: {
    hasPaymentType(value) {
      return _.includes(this.program.settings['organization-payment-types'], value);
    },
    documentsOfType(type) {
      return _.filter(this.documents, doc => {
        if (type === 'landlord-documentation') {
          return doc.file_type === type && doc.household_application_id === this.application.id;
        }
        return doc.file_type === type;
      });
    },
    onUploaded($event) {
      this.$store.dispatch('Landlord/refresh', this.confirmation.id);
      this.$store.dispatch('Application/fetch', this.confirmation.household_application_id);
      this.$store.dispatch('Project/fetchOrgDocument', this.payeeOrganization.id);
    },

    async validateStep() {
      this.errors = {};

      if (this.documentsOfType('landlord-w9').length === 0) {
        this.errors['landlord-w9'] = {errors: ['You must upload at least one W9 document to continue.']};
      }

      if (this.paymentType == 2 && this.documentsOfType('void_check').length === 0) {
        this.errors['void_check'] = {errors: ['You must upload at least one Void Check document to continue.']};
      }

      if ((!this.taxIdNumber || this.taxIdNumber.length !== 9) && !this.maskedTaxIdNumber) {
        this.errors['tax_id_number'] = ['Your tax ID should not contain dashes and must be 9 digits long']
      }


      let size = _.size(this.errors);

      if (size > 0) {
        this.$emit('error', this.errors)
        return false
      }
      ;

      try {
        let url = `/api/landlord/${this.confirmation.id}/step-2`;
        let r = await axios.post(url, {
          payment_on_file: this.paymentInformationComplete,
          payment_type: this.paymentType,
          account_type: this.accountType,
          routing_number: this.maskedRoutingNumber ? -1 : this.routingNumber,
          routing_number_confirmation: this.maskedRoutingNumber ? -1 : this.routingNumberConfirmation,
          account_number: this.maskedAccountNumber ? -1 : this.accountNumber,
          account_number_confirmation: this.maskedAccountNumber ? -1 : this.accountNumberConfirmation,
          project_id: this.project.id,
          tax_id_number: this.maskedTaxIdNumber ? -1 : this.taxIdNumber,
          is_renter_same_manager: this.application.is_renter_same_manager,
          payee_organization_id: this.project.payee_organization_id,
        })
        this.$emit('done', r)
        return true;
      } catch (e) {
        this.errors = e.response.data.errors;
        this.$emit('error', e)
        return false;
      }

    },
    previewFile(document) {
      if (this.permissions.processor) {
        let url = `/applicant/applications/${this.application.id}/documents/${document.id}/preview`;
        this.$refs.editModal.open(url, document);
      } else {
        let url = `/api/landlord/documents/${this.confirmation.id}/${document.id}/preview`;
        this.$refs.previewModal.open(url, document);
      }

    },
    onEditConfirm($event) {
      // this.getData();
    },
    async updatePayeeOrganizationId($event) {
      await this.$store.dispatch('Project/setPayeeOrganizationId', $event.target.value);
      if (this.payeeOrganization) {
        this.paymentType = this.payeeOrganization.payment_type;
        this.accountType = this.payeeOrganization.bank_account_type;
        this.maskedRoutingNumber = this.payeeOrganization.masked_routing_number;
        this.maskedAccountNumber = this.payeeOrganization.masked_account_number;
        this.maskedTaxIdNumber = this.payeeOrganization.masked_tax_id_number;
      } else {
        this.paymentType = null
        this.accountType = null
        this.maskedRoutingNumber = ''
        this.maskedAccountNumber = ''
        this.maskedTaxIdNumber = ''
      }
    }
  }
}
</script>
